import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PriceDistributionService {
  private readonly apiURLprefix: string = '/api';

  constructor(private http: HttpClient) {}

  getFilteredDistribution(
    entityType: 'categories' | 'tags',
    entityId: number,
    filters: { startDate?: string; endDate?: string; costType: 'coin' | 'diamond' }
  ): Observable<any> {
    const url = `${this.apiURLprefix}/${entityType}/${entityId}/price-distribution`;
    
    let params = new HttpParams();
    if (filters.startDate) {
      params = params.set('startDate', filters.startDate);
    }
    if (filters.endDate) {
      params = params.set('endDate', filters.endDate);
    }
    if (filters.costType) {
      params = params.set('costType', filters.costType);
    }
    
    return this.http.get(url, { params });
  }
}

